import { render, staticRenderFns } from "./PeralteePoints.vue?vue&type=template&id=ca7d6f2a&scoped=true&"
import script from "./PeralteePoints.vue?vue&type=script&lang=ts&"
export * from "./PeralteePoints.vue?vue&type=script&lang=ts&"
import style0 from "./PeralteePoints.vue?vue&type=style&index=0&id=ca7d6f2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7d6f2a",
  null
  
)

export default component.exports